// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bm_dQ";
export var articleInfoItem = "bm_dR";
export var itemChild = "bm_dS";